export default function Profile() {
  return <div className="animate-fade-in"><h1 className="text-3xl font-bold">Profile</h1></div>
}
